import constants from 'constants/constants'
import api from './api'

type ContextualHelpResponse = {
    acf: {
        context_for_portal: string
    },
    guid: {
        rendered: string
    }
}[]

export const getContextualHelps = async () => {
    // ID of Lite version category: 7, regular version: 1.
    // TODO: research to use slug instead of id.
    const category = constants.isLite ? 7 : 1
    const response = await api.safeGet<ContextualHelpResponse>(
        `${constants.contextualHelpBaseUrl}wp-json/wp/v2/posts/?_fields=acf,guid&categories=${category}&per_page=100`, { disableAuth: true }
    )
    return response
}

export const getUrlByContext = (contextHelps: ContextualHelpResponse, context: string) => {
    const contextItem = (contextHelps || []).find((e) => (
        (e?.acf?.context_for_portal || []).includes(context)))
    if (contextItem) {
        return (contextItem?.guid?.rendered || '').replace('http:', 'https:')
    }
    return null
}
